import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import PostByAgg from "../../utils/axios";
import ModalAlert from "../../components/ModalAlert";
import LottieLoading from "../../components/child/LottieLoading";
const RegisterPage = () => {
        
    const [musicLabel, setMusicLabel] = useState('');
    const [email, setEmail] = useState('');
    const [address, setAddress] = useState('');
    const [phone, setPhone] = useState('');
    const [country, setCountry] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [province, setProvince] = useState([]);
    const [selectedProvince, setSelectedProvince] = useState(null);
    const [city, setCity] = useState([]);
    const [selectedCity, setSelectedCity] = useState(null);
    const [labelType, setLabelType] = useState([]);
    const [selectedLabelType, setSelectedLabelType] = useState(null);
    const [modal, setModal] = useState(<div></div>);
    const [isLoading, setIsLoading] = useState(false);
    const Navigate = useNavigate();




    const GetCountry = useCallback(() => {
        PostByAgg({
            url: 'location/v1/country/find-by-country-name',
            body: {
                'page': 1,
                'page_size': 200,
            },
            onResponse:onResponseCountry,
            onError:onErrorCountry
        })
    },[]);

    function  onResponseCountry(response) {
        console.log("Response Country: ", response.data.data)
        if (Array.isArray(response.data.data)) {
            setCountry(response.data.data);  // Set the data correctly
        } else {
            console.error("Expected an array of countries, but got:", response.data.data);
            setCountry([]);  // If data is not in the expected format, set an empty array
        }
    }

    function  onErrorCountry(error) {
        console.log("Error Country: ", error)
    }


    const GetProvince = useCallback((countryCode) =>{
        PostByAgg({
            url: 'location/v1/province/find-by-country-code',
            body: {
                'page': 1,
                'page_size': 200,
                'country_code':countryCode
            },
            onResponse:onResponseProvince,
            onError:onErrorProvince
        })
    },[]);

    function  onResponseProvince(response) {
        console.log("Response Province: ", response.data);
        if (Array.isArray(response.data.data)) {
            setProvince(response.data.data)
        }
    }

    function  onErrorProvince(error) {
        console.log("Error Province: ", error)
    }

    const GetCity = useCallback((provinceCode) => {
        PostByAgg({
            url: 'location/v1/city/find-by-province-code',
            body: {
                'page': 1,
                'page_size': 200,
                'province_code':provinceCode
            },
            onResponse:onResponseCity,
            onError:onErrorCity
        })
    },[]);

    function  onResponseCity(response) {
        console.log("Response City: ", response.data.data)
        if (Array.isArray(response.data.data)) {
            setCity(response.data.data)
        }else{
            setCity([])
        }
    }

    function  onErrorCity(error) {
        console.log("Error City: ", error)
    }

    const GetLabelType = useCallback(() =>{  
        PostByAgg({
            url: 'label/lm/v1/label-type/list',
            onResponse:onResponseLabelType,
            onError:onErrorLabelType,
            body: {
                'page': 1,
                'page_size': 200
            }
        })
    },[]);

    function  onResponseLabelType(response) {
        console.log("Response Label Type: ", response.data.data)
        setLabelType(response.data.data.data)
    }

    function  onErrorLabelType(error) {
        console.log("Error Label Type: ", error)
    }

    useEffect(() => {
        GetCountry()
        GetProvince()
        GetCity()
        GetLabelType()
    }, [GetCountry, GetProvince, GetCity, GetLabelType])

    const handleLabelTypeChange = (e) => {
        const labelTypeCode = e.target.value;
        console.log("Selected Label Type Code:", labelTypeCode);  // Debugging
        setSelectedLabelType(labelTypeCode);// Update selected label type code
    };

    const handleCountryChange = (e) => {
        const countryCode = e.target.value;
        console.log("Selected Country Code:", countryCode);  // Debugging
        setSelectedCountry(countryCode);// Update selected country code
        GetProvince(countryCode); // Fetch provinces based on the selected country
    };

    const handleProvinceChange = (e) => {
        const provinceCode = e.target.value;
        console.log("Selected Province Code:", provinceCode);  // Debugging
        setSelectedProvince(provinceCode);// Update selected province code
        GetCity(provinceCode); // Fetch cities based on the selected province
    };

    const handleCityChange = (e) => {
        const cityCode = e.target.value;
        console.log("Selected City Code:", cityCode);  // Debugging
        setSelectedCity(cityCode);// Update selected city code
    }

    const resetForm = () => {
        setMusicLabel('')
        setEmail('')
        setPhone('')
        setAddress('')
        setSelectedCountry(null)
        setSelectedProvince(null)
        setSelectedCity(null)
        setSelectedLabelType(null)
        setCountry([])
        setProvince([])
        setCity([])
        setLabelType([])
    }

    const handleRegister = (e) => {
        e.preventDefault()
        setIsLoading(true);
        const url ='label/lm/v1/music-label/register';
        PostByAgg({
            url: url,
            body: {
                "music_label_name": musicLabel,
                "email": email,
                "telephone": phone,
                "address": address,
                'country_code': selectedCountry,
                'province_code': selectedProvince,
                'city_code': selectedCity,
                'label_type_code': selectedLabelType,
            },
            onResponse:onResponseRegister,
            onError:onErrorRegister
        })
        

        function onResponseRegister(response) {
            setIsLoading(false);
            console.log("Response Register: ", response.data)
            if(response.data !== null || response.data !== undefined){
                let message = response.data.message.id;
                if (typeof message === 'object') { 
                    message = JSON.stringify(message);
                }
                    setModal(
                        <ModalAlert
                            show={true}
                            type={"success"}
                            text={message} 
                            action={() => {
                                setModal(<div></div>)
                                Navigate('/login')
                            }}
                        />
                    )
            }else{
                setModal(
                    <ModalAlert
                        show={true}
                        type={"failed"}
                        text={response.data.message}
                        action={() => {
                            setModal(<div></div>)
                            resetForm()
                        }}
                    />
                )
            }
        }
    
        function  onErrorRegister(error) {
            setIsLoading(false);
            console.log("Error Register: ", error.response.data.message)
            setModal(
                <ModalAlert
                    show={true}
                    type={"failed"}
                    text={error.response.data.message.id}
                    action={() => {
                        setModal(<div></div>)
                        Navigate('/register')
                    }}
                />
            )
        }

    }


    return (
        <section className='auth bg-base d-flex flex-wrap'>
              <div className='auth-left d-lg-block d-none'>
                <div className='d-flex align-items-center flex-column h-100 justify-content-center'>
                  <img src='assets/images/auth/loginHome.jpg' alt='' />
                </div>
              </div>
              <div className='auth-right py-32 px-24 d-flex flex-column justify-content-center'>
                <div className='max-w-464-px mx-auto w-100'>
                  <div>
                    <Link to='/' className='mb-40 max-w-100-px'>
                      <img src='assets/images/ORBIT2.png' alt='' />
                    </Link>
                    <h4 className='mb-12'>Sign Up to your Account</h4>
                    <p className='mb-32 text-secondary-light text-lg'>
                      Welcome back! please enter your detail
                    </p>
                  </div>
                  <form action='#' onSubmit={handleRegister}>
                    <div className='icon-field mb-16'>
                      <span className='icon top-50 translate-middle-y'>
                        <Icon icon='f7:person' />
                      </span>
                      <input
                        type='text'
                        className='form-control h-56-px bg-neutral-50 radius-12'
                        placeholder='Music Label Name'
                        onChange={(e) => setMusicLabel(e.target.value)}
                        value={musicLabel}
                      />
                    </div>
                    <div className='icon-field mb-16'>
                      <span className='icon top-50 translate-middle-y'>
                        <Icon icon='mage:email' />
                      </span>
                      <input
                        type='email'
                        className='form-control h-56-px bg-neutral-50 radius-12'
                        placeholder='Email'
                        onChange={(e) => setEmail(e.target.value.toLowerCase())}
                        value={email}
                      />
                    </div>
                    <div className='icon-field mb-16'>
                      <span className='icon top-50 translate-middle-y'>
                        <Icon icon='material-symbols:phone-iphone' />
                      </span>
                      <input
                        type='telephone'
                        className='form-control h-56-px bg-neutral-50 radius-12'
                        placeholder='Telephone'
                        onChange={(e) => setPhone(e.target.value)}
                        value={phone}
                      />
                    </div>
                    <div className='icon-field mb-16'>
                        <span className='icon'>
                            <Icon icon='material-symbols:location-on'/>
                        </span>
                            <textarea
                                name="Address"
                                className="form-control h-56-px bg-neutral-50 radius-12"
                                placeholder="Address"
                                readOnly=""
                                defaultValue={address}
                                onChange={(e) => setAddress(e.target.value)}
                            />
                    </div>

                    <div className='icon-field mb-16'>
                        <span className='icon top-50 translate-middle-y'>
                            <Icon icon='material-symbols:album'/>
                        </span>
                            <select className='form-select h-56 px-40 bg-neutral-50 justify-content-center radius-10'
                            onChange={handleLabelTypeChange}
                            defaultValue={selectedLabelType || ''}>
                                <option value="">Select Label Type</option>
                            {
                            labelType.length > 0 ? (
                                labelType.map((item, index) => (
                                    <option key={index} value={item.label_type_code}>{item.label_type_name}</option>
                                ))
                            ) : (
                                <option>No options available</option>  // Tampilkan pesan jika labelType kosong atau null
                            )}
                            </select>
                    </div>

                    <div className='icon-field mb-16'>
                        <span className='icon top-50 translate-middle-y'>
                            <Icon icon='material-symbols-light:flag-circle'/>
                        </span>
                            <select className='form-select text-black px-40 bg-neutral-50 justify-content-center radius-10'
                                onChange={handleCountryChange}
                                defaultValue={selectedCountry || ''}>
                             <option value="">Select Country</option>
                            {
                                    country.length > 0 ? (
                                        country.map((item, index) => (
                                            <option key={index} value={item.country_code}>{item.country_name}</option>
                                        ))
                                    ) : (
                                        <option>No options available</option>
                                    )
                                }
                                
                            </select>
                    </div>
                    <div className='icon-field mb-16'>
                        <span className='icon top-50 translate-middle-y'>
                            <Icon icon='material-symbols-light:map-search'/>
                        </span>
                            <select className='form-select bg-neutral-50 justify-content-center h-56 px-40 radius-10'
                                onChange={handleProvinceChange}
                                defaultValue={selectedProvince || ''}
                                disabled={!selectedCountry}
                                >
                             <option value="">Select Province</option>
                            {
                                    province.length > 0 ? (
                                        province.map((item, index) => (
                                            <option key={index} value={item.province_code}>{item.province_name}</option>
                                        ))
                                    ) : (
                                        <option>No options available</option>
                                    )
                                }
                            </select>
                    </div>
                    <div className='icon-field mb-16'>
                        <span className='icon top-50 translate-middle-y'>
                            <Icon icon='material-symbols:location-city'/>
                        </span>
                            <select className='form-select h-56 px-40 bg-neutral-50 justify-content-center radius-10'
                            onChange={handleCityChange}
                            defaultValue={selectedCity || ''}
                            disabled={!selectedProvince}
                            >
                                <option value="">Select City</option>
                            {
                                    city.length > 0 ? (
                                        city.map((item, index) => (
                                            <option key={index} value={item.city_code}>{item.city_name}</option>
                                        ))
                                    ) : (
                                        <option>No options available</option>
                                    )
                                }
                            </select>
                    </div>
                    
                    {/* <div className=''>
                      <div className='d-flex justify-content-between gap-2'>
                        <div className='form-check style-check d-flex align-items-start'>
                          <input
                            className='form-check-input border border-neutral-300 mt-4'
                            type='checkbox'
                            defaultValue=''
                            id='condition'
                          />
                          <label
                            className='form-check-label text-sm'
                            htmlFor='condition'
                          >
                            By creating an account means you agree to the
                            <Link to='#' className='text-primary-600 fw-semibold'>
                              Terms &amp; Conditions
                            </Link>{" "}
                            and our
                            <Link to='#' className='text-primary-600 fw-semibold'>
                              Privacy Policy
                            </Link>
                          </label>
                        </div>
                      </div>
                    </div> */}

                    {isLoading ? (
                        <div className="d-flex justify-content-center">
                            <LottieLoading text="Registering..." />
                        </div>
                        ) : (
                        <button
                        type='submit'
                        className='btn btn-dark text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32'
                        >
                        {" "}
                        Sign Up
                        </button>
                    )}
                    <div className='mt-32 text-center text-sm'>
                      <p className='mb-0'>
                        Already have an account?{" "}
                        <Link to='/login' className='text-primary-600 fw-semibold'>
                          Sign In
                        </Link>
                      </p>
                    </div>
                    {modal}
                  </form>
                </div>
              </div>
        </section>
    )
};

export default RegisterPage;